import { useMutation } from '@tanstack/react-query'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { createVailHistory } from '@/graphql/mutations'
import useMyUser from '@/hooks/useMyUser'
import useMySnackbar from '@/hooks/useSnackbar'
import {
  CreateVailHistoryInput,
  CreateVailHistoryMutation,
  CreateVailHistoryMutationVariables,
} from '@/utils/api'
import graphQLRequest from '@/utils/graphqlClient'
import getDefaultMutations from '@/utils/reactQueryUtils'

const pickHistory = (data: CreateVailHistoryInput) =>
  pick(
    [
      'data',
      'name',
      'notes',
      'platformKeys',
      'id',
      'vailEngagementGoalHistoryId',
      'vailFAQHistoryId',
      'organizationHistoryId',
      'vailSolutionHistoryId',
      'recipeHistoryId',
      'customComponentHistoryId',
      'vailHistoryCreatedById',
    ],
    data
  )

export const useAddHistoryItem = (
  queryKey: (string | undefined)[],
  orgID?: string
) => {
  const params = useParams()
  const me = useMyUser()
  const snackbars = useMySnackbar({
    errorMessage: 'Error creating history',
    successMessage: 'History created successfully',
  })
  return useMutation({
    mutationFn: async (data: CreateVailHistoryInput) => {
      const response = await graphQLRequest<
        CreateVailHistoryMutation,
        CreateVailHistoryMutationVariables
      >(createVailHistory, {
        input: pickHistory({
          ...data,
          organizationHistoryId: orgID ?? params.orgID,
          vailHistoryCreatedById: me.data?.id,
        }),
      })
      return response.data
    },
    mutationKey: ['createHistory'],

    ...getDefaultMutations({ predicate: () => true }, snackbars),
  })
}
